import type { PostProcessorModule } from 'i18next';

import { isTrackingEnabled, trackTranslationKey } from './index';

export const translationTrackerPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'translationTracker',
  process(value: string, key: string | string[], _options: object, translator: { language: string }): string {
    if (isTrackingEnabled()) {
      const keys = Array.isArray(key) ? key : [key];
      keys.forEach((k) => {
        trackTranslationKey(k);
      });
    }
    return value;
  },
};
